import Vue from 'vue';
export const AZEventBus = new Vue();


// WEBPACK FOOTER //
// ./src/components/AZEventBus.js